import NormalButton from 'elements/Button';
import ds from 'designsystem';
import { media } from 'designsystem/index';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';

const Button = NormalButton.extend`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: ${ds.get('metrics.m')};
  height: ${ds.get('metrics.m')};
  margin: 0;
  padding: 0;
  background-color: ${ds.brand('white')};
  outline: none;
  
  ${media.desktop`
    width: 70px;
    height: 70px;
  `};
  
  &:hover, &:focus {
    background-color: ${ds.brand('white')};
    filter: brightness(95%);
  }
  
  &:hover, &:focus ${ArrowLeft} {
    transition-duration: 0.15s;
  }
  
  &:hover, &:focus ${ArrowRight} {
    transition-duration: 0.15s;
  }
  
  &:active {
    background-color: ${ds.brand('white')};
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/blocks/SliderButtons/Button.jsx